import * as Yup from "yup";

export function initialValues(user, userInstitution, nuevo) {
  //console.log("user initialvalue",user.user._id);
  return {
    institutionnam: nuevo ? "" : userInstitution?.institutionnam || "",
    address: nuevo ? "" : userInstitution?.address || "",
    city: nuevo ? "" : userInstitution?.city || "",
    country: nuevo ? "" : userInstitution?.country || "",
    phone: nuevo ? "" : userInstitution?.phone || "",
    website: nuevo ? "" : userInstitution?.website || "",
    plan: nuevo ? "" : userInstitution?.plan || "",
    avatar: nuevo ? "" : userInstitution?.avatar || "",
    fileAvatar: null,
    firstname: nuevo ? "" : userInstitution?.firstname || "",
    lastname: nuevo ? "" : userInstitution?.lastname || "",
    email: nuevo ? "" : userInstitution?.email || "",
    role: "institution",
    partnerId: user.user._id,
    password: "",
    studentsnum: nuevo ? "" : userInstitution?.studentsnum || "25",
    teachersnum: nuevo ? "" : userInstitution?.teachersnum || "3",
  };
}

export function validationSchema(userInstitution) {
  return Yup.object({
    institutionnam: Yup.string().required("La institución es obligatoria"),
    phone: Yup.string()
      .matches(/^[0-9]+$/, "El teléfono solo puede contener números")
      .min(9, "El teléfono debe tener al menos 9 dígitos")
      .required("El teléfono es obligatorio"),
    city: Yup.string().required("La ciudad es obligatoria"),
    plan: Yup.string().required("El plan es obligatorio"),
    firstname: Yup.string().required("El nombre es obligatorio"),
    lastname: Yup.string().required("El apellido es obligatorio"),
    email: Yup.string()
      .email("Debe ser un email válido")
      .required("El email es obligatorio"),
    role: Yup.string().required("El rol es obligatorio"),
    partnerId: Yup.string().required("El partnerId es obligatorio"),
    idClient: Yup.string(),
    password: userInstitution
      ? Yup.string()
      : Yup.string().required(
          "La contraseña es obligatoria si es una nueva institución",
        ),
  });
}
